import { parseEuroToCents } from '../../../shared/utils/installments';

// Accept the Italian currency format and decimal input, without silently rounding.
export function parseCalendarAmount(value) {
  if (value === null || value === undefined || String(value).trim() === '') return null;
  const raw = String(value).trim();
  if (!/^\d+(?:[.,]\d{1,2})?$/.test(raw) && !/^\d{1,3}(?:\.\d{3})+(?:,\d{1,2})?$/.test(raw)) return NaN;
  const cents = parseEuroToCents(raw);
  return Number.isSafeInteger(cents) && cents >= 0 ? cents / 100 : NaN;
}
